var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page flex-col"
  }, [_c("div", {
    staticClass: "section6 flex-row justify-between"
  }, [_c("div", {
    staticClass: "layer1 flex-col",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    staticClass: "imgBack",
    attrs: {
      src: require("../../assets/images/back.png"),
      alt: ""
    },
    on: {
      click: _vm.back
    }
  })]), _c("span", {
    staticClass: "word2"
  }, [_vm._v("New MG Extender_DC")])]), _vm._m(0)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "wrap1 flex-col"
  }, [_c("div", {
    staticClass: "layer2 flex-col"
  }, [_c("img", {
    staticClass: "pic1",
    attrs: {
      referrerpolicy: "no-referrer",
      src: "https://tpage.soimt.com/APP/SNS/brochure_gc.png"
    }
  })])]);
}];
render._withStripped = true;
export { render, staticRenderFns };